var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('location-card',{attrs:{"location":this.location}})],1),_vm._v(" "),_c('b-card',{attrs:{"header":"Lock Groups"}},[_c('b-row',[(this.allowByHausType())?_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('lock-group-form')],1):_vm._e(),_vm._v(" "),(this.allowByHausType())?_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('lock-group')],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8877c58","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/base/haus/LockGroupFormAndList.vue
// module id = null
// module chunks = 